<template>
  <div>
    <v-row>
      <v-col class="pl-3 pb-0 pt-0">
        <label>Applied domains:</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(arr, idx) in splitedDomains" :key="idx">
        <v-checkbox
          class="ma-0 pa-0 small-label-checkbox"
          :multiple="true"
          :required="required"
          v-for="domain in arr"
          :key="domain.name"
          v-model="selected"
          :label="domain.name.toUpperCase()"
          :value="domain._id"
          :rules="rules"
          hide-details
        ></v-checkbox>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="ml-1">
      <div
        v-if="selected !== undefined && selected.length == 0"
        class="v-messages theme--light error--text mt-2"
        role="alert"
      >
        <div class="v-messages__wrapper">
          <div class="v-messages__message">
            {{ rules[0] }}
          </div>
        </div>
      </div>
    </v-row>
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

export default {
  data: () => ({
    selected: undefined,
  }),
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: () => false,
    },
    chunk: {
      type: Number,
      required: false,
      default: 6,
    },
  },
  computed: {
    rules() {
      const isValid = this.selected && this.selected.length > 0;
      return this.required ? [isValid || 'At least one item should be selected'] : [];
    },
    splitedDomains() {
      const splited = [];
      for (let i = 0, j = this.items.length; i < j; i += this.chunk) {
        splited.push(this.items.slice(i, i + this.chunk));
      }
      return splited;
    },
  },
  methods: {
    setSelected(selected) {
      this.selected = selected;
    },
  },
  watch: {
    selected(domains) {
      const selectDomains = domains.filter(d => d !== undefined);
      this.$emit('input', selectDomains.length ? selectDomains : undefined);
    },
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.setSelected(this.value);
    } else {
      this.setSelected(undefined);
    }
  },
};
</script>
